import { CLIENT_PROFILE_COMPONENT_TYPES, COMPONENT_TYPES } from '@atlas/routing';

const {
  All_PROVIDERS,
  BLOG,
  CASINO,
  CASINO_LIVE,
  CLIENT_PROFILE,
  LUCKY_DAY,
  MENU,
  PROMOTION_TOURNAMENTS,
  PROMOTIONS,
  RESULTS,
  SPORT_LIVE,
  SPORT_PREMATCH,
  TOURNAMENTS,
  TV_GAMES,
  VIRTUAL_GAME,
} = COMPONENT_TYPES;

const { MESSAGES, PROMO_CODES } = CLIENT_PROFILE_COMPONENT_TYPES;

export const availableGeneralRoutes = {
  [All_PROVIDERS]: {},
  [BLOG]: {},
  [CASINO]: {},
  [CASINO_LIVE]: {},
  [CLIENT_PROFILE]: {},
  [LUCKY_DAY]: {},
  [LUCKY_DAY]: {},
  [MENU]: {},
  [MESSAGES]: {},
  [PROMOTIONS]: {},
  [PROMOTION_TOURNAMENTS]: {},
  [PROMO_CODES]: {},
  [RESULTS]: {},
  [SPORT_LIVE]: {},
  [SPORT_PREMATCH]: {},
  [TOURNAMENTS]: {},
  [TV_GAMES]: {},
  [VIRTUAL_GAME]: {},
  forgotPassword: {},
  pages: {},
  resetPassword: {},
  settings: {},
  signin: {},
  signup: {},
};

export const defaultRoutes = {
  signin: '/signin',
  signup: '/signup',
  forgotPassword: '/forgotPassword',
  resetPassword: '/resetPassword',
  account: '/account',
  messages: '/account/messages',
  casino: '/casino',
  sportLive: '/live',
  menu: '/menu',
  settings: '/settings',
  sportPrematch: '/sportsbook',
  results: '/results',
  tvGames: '/betgames',
  casinoLive: '/live-casino',
  promotions: '/promotions',
  blog: '/blog',
  promotionTournaments: '/promotion-tournaments',
  staticPage: '/page/:slug',
  virtualGame: '/virtual-game',
  notFound: 'notFound',
  allProvidersPage: '/game-providers',
};
